import {
  useQueryStates,
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  parseAsStringLiteral,
} from 'nuqs'
import {
  JET_ASSIGNMENT_DATE_FIELD_VALUES,
  JET_ASSIGNMENT_SORT_BY_VALUES,
  JET_ASSIGNMENT_SORT_DIR_VALUES,
  JET_ASSIGNMENT_STATUS_VALUES,
} from 'pages/Jet/shared/constants/assignmentStatus'

export const useJetAssignmentsFiltersQueryState = () => {
  return useQueryStates(
    {
      statuses: parseAsArrayOf(
        parseAsStringLiteral(JET_ASSIGNMENT_STATUS_VALUES)
      ),
      assignmentId: parseAsString.withDefault(''),
      shiftId: parseAsString.withDefault(''),
      dateField: parseAsStringLiteral(
        JET_ASSIGNMENT_DATE_FIELD_VALUES
      ).withDefault('created_at'),
      daysAgo: parseAsInteger,
      sortBy: parseAsStringLiteral(JET_ASSIGNMENT_SORT_BY_VALUES).withDefault(
        'created_at'
      ),
      sortDir: parseAsStringLiteral(JET_ASSIGNMENT_SORT_DIR_VALUES).withDefault(
        'desc'
      ),
    },
    {
      urlKeys: {
        statuses: 'statuses',
        assignmentId: 'assignment-id',
        shiftId: 'shift-id',
        dateField: 'date-field',
        daysAgo: 'days-ago',
        sortBy: 'sort-by',
        sortDir: 'sort-dir',
      },
    }
  )
}
